import { ChangeDetectionStrategy, Component, ElementRef, effect, inject } from '@angular/core';
import { NotificationCard } from '../notification-card/notification-card';
import { NotificationService } from '../notification.service';

/**
 * Стопка уведомлений: новые карточки появляются снизу, старые поднимаются вверх.
 *
 * Стопка — поповер: диалоги Material открываются через Popover API, они в
 * верхнем слое браузера, и обычный z-index их не перекрывает. Показываясь позже
 * диалога, стопка оказывается над ним.
 */
@Component({
    selector: 'app-notification-stack',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NotificationCard],
    templateUrl: './notification-stack.html',
    styleUrl: './notification-stack.scss',
    host: { popover: 'manual' },
})
export class NotificationStack {
    private readonly notifications = inject(NotificationService);
    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

    protected readonly items = this.notifications.visible;

    constructor() {
        effect(() => {
            const host = this.host.nativeElement;
            // Браузер без Popover API (и jsdom в тестах) — слой не нужен.
            if (typeof host.showPopover !== 'function') return;

            if (this.items().length > 0) {
                if (!host.matches(':popover-open')) host.showPopover();
            } else if (host.matches(':popover-open')) {
                host.hidePopover();
            }
        });
    }

    protected dismiss(id: number): void {
        this.notifications.dismiss(id);
    }
}
